/*eslint-disable*/
import React from "react";
import HeaderLinksModern from './HeaderLinksModern';

/**
 * HeaderLinks - Modern navigation wrapper
 * Now uses HeaderLinksModern with dropdowns and smooth animations
 */
export default function HeaderLinks(props) {
  return <HeaderLinksModern {...props} />;
}
